<template>
    <div class="center">
        <Card class="card">
            <template #title>
                <div>Forgot Password?</div>
            </template>
            <template #content>
                <div class="p-fluid formgrid grid" v-if="!reset">
                    <div class="field col-12 md:col-12">
                        Enter your registered username
                    </div>
                    <div class="field col-12 md:col-12">
                        <span class="p-float-label input p-input-icon-left">
                            <i class="pi pi-user" />
                            <InputText id="username" type="text" v-model="username" />
                            <label for="username">Username</label>
                        </span>
                    </div>
                    <small v-if="incorrectCredencials" class="p-error" style="padding-left:10px">Username does not
                        exist</small>
                </div>
                <div class="p-fluid formgrid grid" v-else>
                    <div class="field col-12 md:col-12" style="text-align:left">
                        A new password has been sent to your registered email:
                    </div>
                    <div class="field col-12 md:col-12">
                        {{ email }}
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="footer">
                    <Button label="Back" class="p-button-secondary" style="margin-left: .5em" @click='backOnClick()' />
                    <Button v-if="!reset" label="Next" @click='resetOnClick()' :icon="loading" iconPos="right" />
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import CryptoHelper from '@/helper/CryptoHelper';
export default {
    name: 'Reset',
    props: {
        hasAccount: Boolean,
        registered: String
    },
    data() {
        return {
            username: "",
            password: "",

            incorrectCredencials: false,
            reset: false,
            email: "",

            loading: ""
        }
    },
    mounted() {
        console.log(this.registered);
    },
    methods: {
        backOnClick() {
            this.$router.replace({ path: '/Login' });
        },
        resetOnClick() {
            let props = this;
            this.loading = "pi pi-spin pi-spinner";
            this.axios
                .get(`${this.apiEndpoint}user/reset?username=${this.username}`)
                .then(response => {
                    if (response.data) {
                        props.email = response.data;
                        props.reset = true;
                    }
                    else {
                        props.incorrectCredencials = true
                    }
                })
                .catch(error => { props.incorrectCredencials = true; props.loading = "" })
        }
    }
}
</script>

<style scoped>
.card {
    width: 430px;
}

.footer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
}

.input {
    margin-top: 10px;
}

.password>>>input {
    padding-left: 2rem;
}

.p-button {
    width: 110px;
}

.version {
    font-size: 1.1rem;
    padding-top: 0.5rem;
    color: #595959;
}

.center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
</style>